import {createBrowserRouter, Navigate, RouterProvider,} from "react-router-dom";
import App from "./App";
import Workaround from "./pages/workaround";
import ManageAccount from "./pages/manage-account";

export const Providers: React.FC<{ children: React.ReactNode }> = ({
                                                                       children,
                                                                   }) => {
    const router = createBrowserRouter([{
        path: "/", element: <App></App>, children: [{
            path: "", index: true, element: <Navigate to="/workaround" replace/>,
        }, {
            path: "manage-account", element: <ManageAccount></ManageAccount>,
        }, {
            path: "workaround", index: false, element: <Workaround></Workaround>,
        },],
    },], {basename: ""},);
    return <RouterProvider router={router}></RouterProvider>;
};
